import {
  ServiceCategory,
  ResidentialSubcategory,
  BusinessSubcategory,
} from '../../models/user.model';

export interface SubcategoryInfo {
  key: ResidentialSubcategory | BusinessSubcategory;
  labelKey: string;
  descriptionKey: string;
  estimatedMinHours: number;
  estimatedMaxHours: number;
}

export interface CategoryInfo {
  key: ServiceCategory;
  labelKey: string;
  descriptionKey: string;
  subcategories: SubcategoryInfo[];
}

export const SERVICE_TAXONOMY: CategoryInfo[] = [
  {
    key: ServiceCategory.RESIDENTIAL,
    labelKey: 'services.residential.label',
    descriptionKey: 'services.residential.description',
    subcategories: [
      {
        key: ResidentialSubcategory.REGULAR_CLEANING,
        labelKey: 'services.residential.regular.label',
        descriptionKey: 'services.residential.regular.description',
        estimatedMinHours: 1,
        estimatedMaxHours: 12,
      },
      {
        key: ResidentialSubcategory.DEEP_CLEANING,
        labelKey: 'services.residential.deep.label',
        descriptionKey: 'services.residential.deep.description',
        estimatedMinHours: 2,
        estimatedMaxHours: 12,
      },
      {
        key: ResidentialSubcategory.WINDOW_CLEANING,
        labelKey: 'services.residential.windowCleaning.label',
        descriptionKey: 'services.residential.windowCleaning.description',
        estimatedMinHours: 1,
        estimatedMaxHours: 6,
      },
      {
        key: ResidentialSubcategory.RESIDENTIAL_SOLAR_PANELS,
        labelKey: 'services.residential.solarPanels.label',
        descriptionKey: 'services.residential.solarPanels.description',
        estimatedMinHours: 1,
        estimatedMaxHours: 4,
      },
      {
        key: ResidentialSubcategory.RESIDENTIAL_GUTTER_CLEANING,
        labelKey: 'services.residential.gutterCleaning.label',
        descriptionKey: 'services.residential.gutterCleaning.description',
        estimatedMinHours: 1,
        estimatedMaxHours: 4,
      },
    ],
  },
  {
    key: ServiceCategory.BUSINESS,
    labelKey: 'services.business.label',
    descriptionKey: 'services.business.description',
    subcategories: [
      {
        key: BusinessSubcategory.OFFICE_CLEANING,
        labelKey: 'services.business.office.label',
        descriptionKey: 'services.business.office.description',
        estimatedMinHours: 2,
        estimatedMaxHours: 8,
      },
      {
        key: BusinessSubcategory.BUSINESS_DEEP_CLEANING,
        labelKey: 'services.business.deep.label',
        descriptionKey: 'services.business.deep.description',
        estimatedMinHours: 4,
        estimatedMaxHours: 12,
      },
      {
        key: BusinessSubcategory.BUSINESS_WINDOWS,
        labelKey: 'services.business.windows.label',
        descriptionKey: 'services.business.windows.description',
        estimatedMinHours: 2,
        estimatedMaxHours: 8,
      },
      {
        key: BusinessSubcategory.BUSINESS_SOLAR_PANELS,
        labelKey: 'services.business.solarPanels.label',
        descriptionKey: 'services.business.solarPanels.description',
        estimatedMinHours: 2,
        estimatedMaxHours: 8,
      },
    ],
  },
];

export function getCategoryByKey(key: ServiceCategory): CategoryInfo | undefined {
  return SERVICE_TAXONOMY.find((cat) => cat.key === key);
}

export function getSubcategoryByKey(
  category: ServiceCategory,
  sub: ResidentialSubcategory | BusinessSubcategory
): SubcategoryInfo | undefined {
  const c = getCategoryByKey(category);
  return c?.subcategories.find((s) => s.key === sub);
}
